<template>
  <div class="other-way">
    <div class="other-way-txt">
      <div class="line"></div>
      <div class="txt font-size14 color-cue">其他登录方式</div>
    </div>
    <div class="other-way-option">
      <a :href="CONF.APIList.QQLogin+search+'&channel='+channel"><div class="option-qq option"></div></a>
      <a :href="CONF.APIList.WXLogin+search+'&isMobile='+isMobile+'&channel='+channel"><div class="option-wx option"></div></a>
     <slot></slot>
    </div>
  </div>
</template>
<style>
  .content .other-way{
    width: 100%;
    height:65px;
    position: relative;
    margin-top: 35px;
  }
  .content .other-way .other-way-txt, .content .other-way .other-way-option{
    width: 100%;
    height:30px;
    margin-bottom: 5px;
    line-height: 30px;
  }
  .content .other-way .other-way-txt .line{
    width: 100%;
    height: 1px;
    background-color: #dedede;
    position: absolute;
    left: 0;
    top:14.5px;
    z-index: 1;
  }
  .content .other-way .other-way-txt .txt{
    width: 120px;
    height: 30px;
    position: absolute;
    left: 120px;
    top:0;
    background-color: #ffffff;
    z-index: 10;
    text-align: center;
  }
  @font-face {
    font-family: 'icomoon';
    src:  url('../assets/fonts/icomoon.eot?vbo5gh');
    src:  url('../assets/fonts/icomoon.eot?vbo5gh#iefix') format('embedded-opentype'),
    url('../assets/fonts/icomoon.ttf?vbo5gh') format('truetype'),
    url('../assets/fonts/icomoon.woff?vbo5gh') format('woff'),
    url('../assets/fonts/icomoon.svg?vbo5gh#icomoon') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  .option-qq:before {
    content: "\e900";
  }
  .option-wx:before {
    content: "\e901";
  }
  [class^="option-"], [class*=" option-"] {
    font-family: 'icomoon' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .content .other-way .other-way-option .option{
    width: 24px;
    height: 24px;
    margin-top: 3px;
    float:left;
    font-size: 24px;
    color: #999999;
  }
  .content .other-way .other-way-option .option-account{
    overflow: hidden;
    text-align: right;
  }
  .content .other-way .other-way-option .option{
    margin-right: 30px;
  }
  .content .other-way .other-way-option .option-qq:hover{
    color: #097ce0;
  }
  .content .other-way .other-way-option .option-wx:hover{
    color:#19d03b;
  }
  @media screen and (max-width: 360px) {
  .content .other-way .other-way-txt .txt {
    width: 33.33%;
    left: 33.33%;
    }
  }
</style>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  export default {
    data () {
      return {
        CONF: CONF,
        isMobile: false,
        search: window.location.search.replace('?', '&'),
        channel: ''
      }
    },
    created () {
      this.isMobile = server.isMobile()
      this.channel = server.getChannelType(this.$route.query.callback)
    }
  }
</script>



// WEBPACK FOOTER //
// otherWay.vue?5f2867d6